/** Dollars and cents for the admin billing screens. Amounts are whole cents everywhere in the database. */

/** "$1,234.50", "-$5.00" (never "$-5.00"). */
export function formatMoney(cents: number): string {
  const abs = Math.abs(Math.round(cents));
  const dollars = Math.floor(abs / 100).toLocaleString("en-AU");
  return `${cents < 0 ? "-" : ""}$${dollars}.${String(abs % 100).padStart(2, "0")}`;
}

/** A service's price as shown to staff: "$45.00", or "from $45.00" when it is a starting price, or "-" when it has none. */
export function formatServicePrice(priceCents: number | null | undefined, priceFrom: boolean | null | undefined): string {
  if (priceCents == null) return "-";
  const amount = `$${(priceCents / 100).toFixed(2)}`;
  return priceFrom ? `from ${amount}` : amount;
}

/**
 * What a person typed into a dollar amount box -> whole cents, or null when it is not a plain positive amount.
 * Accepts "12", "12.5", "12.50", "$12.50", "1,234.50" and surrounding spaces; refuses a sign, a third decimal place,
 * letters, an empty box and zero (the direction -- credit or charge -- is chosen separately, never typed as a minus).
 */
export function dollarsToCents(text: string): number | null {
  const t = text.trim().replace(/^\$/, "").replace(/,/g, "");
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  const [d, c = ""] = t.split(".");
  const cents = Number(d) * 100 + Number(c.padEnd(2, "0"));
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
}
